<template lang="html">
    <div class="card" style="display: flex; flex-grow: 1; flex-direction: column; max-height: 100%;">
        <div class="card-body mb-n2" style="display: flex; flex-grow: 1; flex-direction: column; max-height: 100%;">
            <DropDownSearch class="drop mb-2"
                            :items="consultants"
                            v-on:dropdownClick="consultantClicked"
                            :currentValue="consultant"
                            defaultLabel="Filtrer par Consultant"
                            shownKey="fullname"
                            :showSearchField="true"></DropDownSearch>
            <!--.debug {{selectable}}-->
            <div class="search-input-container border border-separator rounded-md bg-foreground mb-4">
                <input class="form-control search"
                       type="text"
                       autocomplete="off"
                       placeholder="Rechercher"
                       v-model="search_string"/>
                <span class="search-magnifier-icon">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="20"
                         height="20"
                         viewBox="0 0 20 20"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="1.5"
                         stroke-linecap="round"
                         stroke-linejoin="round"
                         class="acorn-icons acorn-icons-search undefined">
                        <circle cx="9" cy="9" r="7"></circle>
                        <path d="M14 14L17.5 17.5"></path>
                    </svg>
                </span>
            </div>
            <div style="flex-grow: 1; max-height: calc(100vh - 200px);overflow:hidden;overflow-y:scroll;">
                <EstablishmentList :filters="filters"
                                   :height="height"
                                   :selectable="selectable">
                </EstablishmentList>
            </div>
        </div>
    </div>
</template>
 
<style scoped>

</style>

<script>
import EstablishmentList from '@/components/EstablishmentList';
import DropDownSearch from '@/components/ui/DropDownSearch';
import utils from '@/utils.js';
import gql from '@/gqlService.coffee';

export default {
  name: 'EstablishmentListFilterTeam',
  components: {
    EstablishmentList,
    DropDownSearch
  },
  props: {
    selectable: Boolean
  },
  data() {
    return {
      search_string: "",
      height: null,
      listHeight: null,
      consultant: { lastname: null },
      consultants: gql.query({
        model: "consultant_set",
        fields: "uid lastname firstname fullname"
      })
    };
  },
  computed: {
    filters() {
      return {
        consultant: this.consultant,
        search_string: this.search_string
      };
    }
  },
  methods: {
    setHeight: utils.debounce(function () {
      this.height = (window.innerHeight - 165) + "px";
    }, 500),
    consultantClicked(data) {
      this.consultant = data || { name: null };
    }
  },
  mounted() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeight);
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card-header-title{
    padding:0 0 10px 0;
}
.card-content{
    padding:10px;
}
</style>
